import { jwtDecode } from "jwt-decode";
import { Navigate, useLocation } from "react-router-dom";

import {
  useLazyGetV2PersonsByIdQuery,
  useLazyGetV2PersonsByPersonIdDoctorsQuery,
  usePostAuthenticationRefreshTokenMutation,
} from "../app/apiRTK";
import { useAppSelector, useAuth } from "../app/hooks";
import { EnumRoles, IDecoded } from "../app/types";
import Preloader from "../components/AntPreloader";
import {
  authAccessState,
  authRefreshState,
  authRoleState,
  authStatusState,
} from "../storeSlices/login";
import ErrorPage from "./ErrorPage";

export function PrivateOutlet({ children }: { children: any }) {
  // const auth = useAuth();
  const location = useLocation();

  const authState = useAppSelector(authStatusState);
  const access = useAppSelector(authAccessState);
  const refresh = useAppSelector(authRefreshState);
  const role = useAppSelector(authRoleState);

  // useMutation
  const [refreshLogin] = usePostAuthenticationRefreshTokenMutation();

  // useLazy
  const [getAuthPerson] = useLazyGetV2PersonsByIdQuery();
  // const [getAuthDoctor] = useLazyGetV2DoctorsGetByPersonIdByPersonIdQuery();
  const [getAuthDoctor] = useLazyGetV2PersonsByPersonIdDoctorsQuery();

  if (!sessionStorage.getItem("firstEntry") && location.pathname !== "/login") {
    sessionStorage.setItem("firstEntry", location.pathname);
  }

  if ((authState === "guest" || authState === "loading") && access && refresh) {
    if (authState === "loading") {
      return (
        <Preloader size="large">
          <div style={{ width: "100wh", height: "100vh" }}></div>
        </Preloader>
      );
    } else {
      refreshLogin({ refresh })
        .unwrap()
        .then(({ access }) => {
          if (access) {
            const accessDecoded: IDecoded = jwtDecode(access);
            const personId = accessDecoded.PersonId;
            const roles = accessDecoded.Role;
            if (personId) {
              getAuthPerson(personId);

              if (roles.includes(EnumRoles.Врач)) {
                getAuthDoctor(personId);
              }
            }
          }
        });

      return (
        <Preloader size="large">
          <div style={{ width: "100wh", height: "100vh" }}></div>
        </Preloader>
      );
    }
  }

  if (
    (authState === "guest" || authState === "failedRefresh") &&
    location.pathname !== "/login"
  ) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Если пользователь авторизован и имеет роль "Сотрудник поликлиники",
  // то он может видеть только страницу GIS-интеграции и страницу логина.
  // Всё остальное — показываем ErrorPage ("Упс") без интерфейса Root.
  if (
    role &&
    role.includes(EnumRoles.Сотрудник) &&
    location.pathname !== "/login" &&
    !location.pathname.startsWith("/integration/gis/patients/")
  ) {
    return <ErrorPage />;
  }

  return children;
}
